import { render, staticRenderFns } from "./game.vue?vue&type=template&id=68c94b02&"
import script from "./game.vue?vue&type=script&lang=ts&"
export * from "./game.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\sam_project\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c94b02')) {
      api.createRecord('68c94b02', component.options)
    } else {
      api.reload('68c94b02', component.options)
    }
    module.hot.accept("./game.vue?vue&type=template&id=68c94b02&", function () {
      api.rerender('68c94b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/game.vue"
export default component.exports